import React from "react";
import { CellProps } from "react-table";
import AgTable from "../../../components/AgTable";
import { Log } from "../../../models";
import { DEFAULT_VALUE, OFFERING_TYPE } from "../../../utils/constant";
import { formatDateTimeNoSecond, formatDateTimeToLocalTime } from "../../../utils/helper";
import { IChangeLogTabProps } from "./changeLogTab.props";
import { convertOfferingToName } from "../../../utils/convertHelper";

const ChangeLogTab: React.FC<IChangeLogTabProps> = ({
	data,
	maxLength,
	entriesPerPage = DEFAULT_VALUE.ENTRIES_PER_PAGE,
	onHandleNextPage,
	page = 1,
	pageCount,
	isLoading,
	offeringType,
	...props
}: IChangeLogTabProps) => {
	const columns = React.useMemo(
		() => [
			{
				Header: "User",
				width: "20%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return (
						<div className="flex flex-col items-start">
							<p className="text-[14px] text-[#58585B] font-medium m-0 p-0">{`${rowData.fkIndividual?.firstName} ${rowData.fkIndividual?.lastName}`}</p>
							<p className="text-[14px] text-[#637381] font-normal m-0 p-0">
								{rowData.fkIndividual?.individualEmailAddr}
							</p>
						</div>
					);
				},
			},
			{
				Header: "Organization",
				width: "22%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return (
						<p className="">
							{rowData.fkIndividual?.fkOrg?.orgName}
						</p>
					);
				},
			},
			{
				Header: "Action",
				width: "10%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return <p className="">{rowData.actionLog}</p>;
				},
			},
			{
				Header: `Organization Profile ${offeringType !== OFFERING_TYPE.ORGANIZATION ? `- ${convertOfferingToName(offeringType ?? OFFERING_TYPE.SERVICE)}` : ""}`,
				width: "26%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return (
						offeringType !== OFFERING_TYPE.ORGANIZATION ?
						<p>{rowData.fkOrgId !== rowData.fkToOrgId && rowData.fkOrg && rowData.fkToOrg?.orgName}{rowData.fkOrgId !== rowData.fkToOrgId && rowData.fkOrg && rowData.mainServiceName && " - "}{rowData.mainServiceName}</p>
						:
						<p>{rowData.fkOrgId !== rowData.fkToOrgId && rowData.fkOrg && rowData.fkOrg?.orgName}{rowData.fkOrgId !== rowData.fkToOrgId && rowData.fkOrg && rowData.mainServiceName && " - "}{rowData.mainServiceName}</p>
					);
				},
			},
			{
				Header: "Time stamp",
				width: "15%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return (
						<p className="">
							{formatDateTimeNoSecond(formatDateTimeToLocalTime(rowData.createdAt))}
						</p>
					);
				},
			},
		],
		[offeringType],
	);

	return (
		<AgTable
			columns={columns}
			data={data}
			maxLength={maxLength}
			entriesPerPage={entriesPerPage}
			onHandleNextPage={onHandleNextPage}
			page={page}
			pageCount={pageCount}
			isLoading={isLoading}
		/>
	);
};

export default React.memo(ChangeLogTab);
